export default {
  getUserSource (state) {
    return state.selectedUserSource
  }
}
